import request from '@/utils/request';
//appid列表
export function getMiniProgramAccountList() {
  return request('/wechat/queryWechatMiniProgramAccountList', {
    method: 'GET',
    // data: values,
  });
}
//新增自动回复规则列表
export function addReplyRule(values) {
  return request('/wechat/reply/addReplyRule', {
    method: 'POST',
    data: values,
  });
}

//更新自动回复规则
export function updateReplyRule(values) {
  return request('/wechat/reply/updateReplyRule', {
    method: 'POST',
    data: values,
  });
}
//查询单个自动回复规则
export function getReplyRuleDetail(values) {
  return request('/wechat/reply/queryReplyRule', {
    method: 'POST',
    data: values,
  });
}
//同步关注自动回复
export function synSubscribeReply(values) {
  return request('/wechat/reply/synSubscribeReply', {
    method: 'POST',
    data: values,
  });
}
